import * as React from 'react';
import CheckBox from '../Checkbox';
import { generateNewGuid } from '../../containers/WorkkardDetail/utils';
import { CharConstants,StringConstants } from '../../containers/WorkkardDetail/constants';
import FileView from '../FileView';
import UserImage from '../UserImage/index';

class LetterCell extends React.Component{
    constructor(props) {
        super(props);
        this.letterUrlData = null,
        this.state = {
            isSelected:false,
        }

        this.isThisClicked =this.isThisClicked.bind(this);
    }

    isThisClicked(event){
        this.setState({
            isSelected : event.target.checked
        })
    }

    render(){
        const {author,letterUrl,templateName, requesterComments,createdAt}  = this.props.data;
        const parsedDate = `${moment(createdAt).format("DD/MM/YYYY")} at ${moment(createdAt).format("hh:mm a")}`;
        const date = parsedDate.split('at');
        const isSelected = this.props.extraData.totalSelectedFiles && this.props.extraData.totalSelectedFiles.some(({guid})=>guid == letterUrl.FileGuid);

        const letterData = { Files : [letterUrl]}

        return(
            <li>
                <div className="logCardsWrapper ltrLogPop">
                    <div className="letterCheckboxArea" >
                        <CheckBox item={{ id:letterUrl.FileGuid,
                         checked:isSelected}}
                         handleCheckbox={(e)=> {
                            this.props.onItemClick({
                                "guid":     letterUrl.FileGuid,
                                "newguid":  generateNewGuid(),
                                "name":     letterUrl.FileName,
                                "size" :    letterUrl.FileSize,
                                "filesrc" : this.props.extraData.noteType== CharConstants.Activity?StringConstants.activity:StringConstants.workkard ,
                                "caption" : letterUrl.Caption,
                                "url" :     letterUrl.FileUrl
                            }),
                            this.isThisClicked(e)
                        }} />
                    </div>

                    <div className="lttrDetailsCard lttrDialogCard">
                    <div className="cardLeft cardDialog">
                        <div className="userIcon ltrUserIcon">                            
					 <UserImage profileUrl={author.ProfileImage} profileName={author.FirstName + author.LastName }/>
                        </div>
                        <div className="lttrDesc">
                            <span>
                               {author.FirstName} {author.LastName}
                                <span className="timeText">
                                    {date[1]}
                                </span>
                            </span>
                            <span>
                                {templateName}
                            </span>
                            <div className="lttrNote">
                                <span>{requesterComments.message}</span>
                            </div>
                            <div className="fileAttachment">
                            <FileView fileData={letterData} galleryData={[]}/> 
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default LetterCell;